import { useChapterStore } from '../../shared/store/useChapterStore';
import {
  CREATE_CHAPTER_NOTE,
  FETCH_CHAPTER_NOTES,
  FindChapterNotesQuery,
  FindChapterNotesQueryVariables,
  UPDATE_CHAPTER_NOTE,
} from '@edwin-group/cj-graphql';
import { useMutation, useQuery } from '@apollo/client';
import { useMissionStore } from '../../shared/store/useMissionStore';
import { useAuthentication } from '@/hooks/useAuthentication';
import { useState } from 'react';

export const useNotes = () => {
  const chapter = useChapterStore((state) => state.chapter);
  const mission = useMissionStore((state) => state.mission);
  const { authentication } = useAuthentication();
  const [value, setValue] = useState('');
  const [documentId, setDocumentId] = useState('');

  useQuery<FindChapterNotesQuery, FindChapterNotesQueryVariables>(FETCH_CHAPTER_NOTES, {
    variables: {
      missionDocumentId: mission?.documentId || '',
      chapterUUID: chapter?.uuid || '',
      staffDocumentId: authentication?.user?.documentId || '',
    },
    skip: !mission?.documentId || !chapter?.uuid || !authentication?.user?.documentId,
    onCompleted: (data) => {
      if (data.chapterNotes.length && data.chapterNotes[0]) {
        setValue(data.chapterNotes[0].notes || '');
        setDocumentId(data.chapterNotes[0].documentId || '');
      }
    },
  });

  const [createNotes, { loading: createNotesLoading }] = useMutation(CREATE_CHAPTER_NOTE, {
    refetchQueries: [
      {
        query: FETCH_CHAPTER_NOTES,
        variables: {
          missionDocumentId: mission?.documentId,
          chapterUUID: chapter?.uuid,
          staffDocumentId: authentication?.user?.documentId,
        },
      },
    ],
  });

  const [updateNotes, { loading: updateNotesLoading }] = useMutation(UPDATE_CHAPTER_NOTE, {
    refetchQueries: [
      {
        query: FETCH_CHAPTER_NOTES,
        variables: {
          missionDocumentId: mission?.documentId,
          chapterUUID: chapter?.uuid,
          staffDocumentId: authentication?.user?.documentId,
        },
      },
    ],
  });

  const onChangeValue = (text: string) => {
    setValue(text);
  };

  function onChangeNotes(text: string) {
    if (!mission?.documentId || !chapter?.uuid || !authentication?.user?.documentId) return;

    if (documentId) {
      updateNotes({
        variables: {
          documentId: documentId,
          data: { notes: text },
        },
      });
      return;
    }

    createNotes({
      variables: {
        data: {
          notes: text,
          staff: authentication.user.documentId,
          mission: mission.documentId,
          chapterUUID: chapter.uuid,
        },
      },
    })
      .then((res) => {
        setDocumentId(res.data.createChapterNote.documentId);
      })
      .catch((err) => {
        console.error('ChapterNotesError', err);
      });
  }

  return {
    value,
    createNotesLoading,
    updateNotesLoading,
    onChangeValue,
    onChangeNotes,
  };
};
